import React from "react";
import { connect } from "react-redux";
import { setFinanceType } from "../redux/actions";
import { isCfa, isCfnz } from "../redux/selectors";
import FinanceMsa from "./FinanceMsa";
import Originator from "./Originator";
import { Col, Form, Row } from "react-bootstrap";
import { IS_NZ } from "../constants";


function QuoteFinance({
  isMsa,
  isCfa,
  isCfnz,
  financeType,
  opportunityFinanceType,
  setFinanceType
}) {
  return (
    <>
      <Form.Group as={Row} controlId="financeType">
        <Form.Label sm={3} column>
          Finance Type
        </Form.Label>

        <Col sm={3}>
          <Form.Control
            as="select"
            onChange={e => setFinanceType(e.target.value)}
            value={financeType}
          >
            <option value={IS_NZ ? "CFNZ" : "CFA"}>{IS_NZ ? "CFNZ" : "CFA"}</option>
            <option value="CASH">Cash</option>
          </Form.Control>
        </Col>

        <Col sm={{ span: 9, offset: 3 }}>
          <small className="form-text text-warning">
            The Finance Type in your opportunity is{" "}
            <strong>{opportunityFinanceType}</strong>. If you change the Finance
            Type in your quote here, please review the quote carefully.
          </small>
        </Col>
      </Form.Group>

      {isCfa && (isMsa ? <FinanceMsa /> : <Originator />)}
      {isCfnz ? <Originator /> : null}
    </>
  );
}

export default connect(
  state => ({
    isMsa: state.quote.isMsa,
    isCfa: isCfa(state),
    isCfnz: isCfnz(state),
    financeType: state.quote.finance.financeType,
    opportunityFinanceType: state.opportunity.FinanceType
  }),
  { setFinanceType }
)(QuoteFinance);
